module.exports = __webpack_public_path__ + "static/media/android-black-circle.438160fa.svg";